import { motion } from "framer-motion";
import { Check, ShoppingBag } from "lucide-react";

const PRODUCT_IMG =
  "https://customer-assets.emergentagent.com/job_ahaario-snacks/artifacts/tu7itdkc_EFAC8672-9F82-43BE-AF88-AF121CF76BC0%202.PNG";
const AMAZON_URL = "https://amzn.in/d/02dgPPzh";

const FEATURES = [
  "Hand-picked premium fox nuts",
  "Sourced directly from Bihar farms",
  "Hygienically packed in 200g resealable pouch",
  "No additives, no preservatives, ever",
];

export default function ProductShowcase() {
  return (
    <section
      id="product"
      className="relative py-24 md:py-32 bg-white overflow-hidden"
      data-testid="product-showcase-section"
    >
      <div className="absolute inset-0 -z-0">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 h-[500px] w-[500px] rounded-full bg-[#A7D129]/20 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative order-2 lg:order-1"
        >
          <div className="relative rounded-[2.5rem] bg-gradient-to-br from-[#F9F9F6] to-[#F2E8D5]/60 p-8 md:p-14 border border-[#E8EDE6] overflow-hidden">
            <div className="absolute -top-16 -right-16 h-60 w-60 rounded-full bg-[#A7D129]/40 blur-3xl" />
            <div className="absolute -bottom-20 -left-10 h-72 w-72 rounded-full bg-[#3E7D2B]/15 blur-3xl" />
            <img
              src={PRODUCT_IMG}
              alt="Ahaario Premium Raw Makhana 200g - product close up"
              className="relative w-full max-w-[460px] mx-auto drop-shadow-[0_24px_40px_rgba(62,125,43,0.3)]"
              data-testid="product-showcase-image"
            />
            <div className="absolute top-8 left-8 bg-white rounded-2xl px-4 py-2 shadow-md border border-[#E8EDE6]">
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#4A5D44] font-bold">
                Net Wt.
              </p>
              <p className="font-display font-black text-2xl text-[#3E7D2B]">200g</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="order-1 lg:order-2"
        >
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-[#3E7D2B]">
            The Hero Pack
          </p>
          <h2 className="font-display font-black text-[#13240D] mt-4 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Premium Raw{" "}
            <span className="italic text-[#3E7D2B]">Makhana</span>
          </h2>
          <p className="mt-5 text-lg text-[#4A5D44] leading-relaxed max-w-xl">
            Light, airy and beautifully crunchy. Roast them with ghee &amp; salt,
            toss them in a salad, or simply snack them straight from the pouch.
            Always wholesome, always delicious.
          </p>

          <ul className="mt-8 space-y-4">
            {FEATURES.map((f) => (
              <li
                key={f}
                className="flex items-start gap-3 text-[#13240D] text-base md:text-lg"
              >
                <span className="mt-1 h-6 w-6 rounded-full bg-[#3E7D2B] flex items-center justify-center flex-shrink-0">
                  <Check className="h-4 w-4 text-white" strokeWidth={3} />
                </span>
                <span className="font-medium">{f}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10">
            <a
              href={AMAZON_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="product-buy-now-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#3E7D2B] hover:bg-[#2D5C1F] text-white rounded-full px-8 py-4 font-bold transition-all duration-300 hover:-translate-y-1 hover:shadow-xl shadow-[#3E7D2B]/25"
            >
              <ShoppingBag className="h-5 w-5" /> Buy Now on Amazon
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
